import { Card, Button } from 'react-bootstrap';

const PersonalDetailsSection = ({ employee, onPreview }) => {
  const personal = employee?.personal || {};
  const currentAddress = personal.currentAddress || {};
  const permanentAddress = personal.permanentAddress || {};
  const emergencyContact = personal.emergencyContact || {};

  const formatDate = (date) => {
    if (!date) return 'N/A';
    try {
      // Handle Firestore Timestamp
      if (date.seconds) {
        return new Date(date.seconds * 1000).toLocaleDateString('en-IN');
      }
      // Handle string date
      if (typeof date === 'string') {
        const parsedDate = new Date(date);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toLocaleDateString('en-IN');
        }
      }
      // Handle Date object
      if (date instanceof Date && !isNaN(date.getTime())) {
        return date.toLocaleDateString('en-IN');
      }
      return 'Invalid Date';
    } catch (error) {
      return 'Invalid Date';
    }
  };

  return (
    <Card className="mb-3 border-0 shadow-sm rounded-3 overflow-hidden">
      <Card.Header className="bg-primary text-white py-2 py-md-3">
        <h6 className="mb-0 fw-bold">Personal Details</h6>
      </Card.Header>
      <Card.Body className="p-3">
        <div className="profile-field">
          <div className="profile-field-label">Full Name:</div>
          <div className="profile-field-value">{personal.fullName || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Email:</div>
          <div className="profile-field-value">{personal.email || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Phone:</div>
          <div className="profile-field-value">{personal.phone || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Date of Birth:</div>
          <div className="profile-field-value">{formatDate(personal.dateOfBirth)}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Age:</div>
          <div className="profile-field-value">{personal.age || 'N/A'} years</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Gender:</div>
          <div className="profile-field-value">{personal.gender || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Marital Status:</div>
          <div className="profile-field-value">{personal.maritalStatus || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Blood Group:</div>
          <div className="profile-field-value">{personal.bloodGroup || 'N/A'}</div>
        </div>

        <h6 className="mt-4 mb-3 text-primary">KYC Details</h6>
        <div className="profile-field">
          <div className="profile-field-label">Aadhaar Number:</div>
          <div className="profile-field-value">{personal.aadhaarNumber || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">PAN Number:</div>
          <div className="profile-field-value text-uppercase">{personal.panNumber || 'N/A'}</div>
        </div>
        {personal.aadhaarScan && (
          <div className="profile-field">
            <div className="profile-field-label">Aadhaar Scan:</div>
            <div className="profile-field-value">
              <Button 
                variant="outline-info"
                size="sm"
                className="py-0"
                onClick={() => onPreview(personal.aadhaarScan, 'Aadhaar Card Scan')}
              >
                View Aadhaar Scan
              </Button>
            </div>
          </div>
        )}
        {personal.panScan && (
          <div className="profile-field">
            <div className="profile-field-label">PAN Scan:</div>
            <div className="profile-field-value">
              <Button 
                variant="outline-info"
                size="sm"
                className="py-0"
                onClick={() => onPreview(personal.panScan, 'PAN Card Scan')}
              >
                View PAN Scan
              </Button>
            </div>
          </div>
        )}

        <h6 className="mt-4 mb-3">Current Address</h6>
        <div className="profile-field">
          <div className="profile-field-value">
            {currentAddress.line1 && <div>{currentAddress.line1}</div>}
            {currentAddress.line2 && <div>{currentAddress.line2}</div>}
            {currentAddress.city && <div>{currentAddress.city}, {currentAddress.state} - {currentAddress.pincode}</div>}
            {currentAddress.country && <div>{currentAddress.country}</div>}
            {!currentAddress.line1 && 'N/A'}
          </div>
        </div>

        <h6 className="mt-4 mb-3">Permanent Address</h6>
        <div className="profile-field">
          <div className="profile-field-value">
            {permanentAddress.line1 && <div>{permanentAddress.line1}</div>}
            {permanentAddress.line2 && <div>{permanentAddress.line2}</div>}
            {permanentAddress.city && <div>{permanentAddress.city}, {permanentAddress.state} - {permanentAddress.pincode}</div>}
            {permanentAddress.country && <div>{permanentAddress.country}</div>}
            {!permanentAddress.line1 && 'N/A'}
          </div>
        </div>

        <h6 className="mt-4 mb-3">Emergency Contact</h6>
        <div className="profile-field">
          <div className="profile-field-label">Name:</div>
          <div className="profile-field-value">{emergencyContact.name || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Relation:</div>
          <div className="profile-field-value">{emergencyContact.relation || 'N/A'}</div>
        </div>
        <div className="profile-field">
          <div className="profile-field-label">Phone:</div>
          <div className="profile-field-value">{emergencyContact.phone || 'N/A'}</div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PersonalDetailsSection;
